export class CmpTaskCommentInsertDto {
    cmpTaskCommentId: string;
    taskId: string;
    isCustomerVisible: boolean;
    comment: string;
}